<ng-container *transloco="let translate">
    <span class="searchFilters" (click)="onDateSearchFocus()">
        <span [textContent]="translate('Filter by date')"></span>
        <span class="material-icons filter-icon-alignment">filter_alt</span>
    </span>

    <!-- Search slider -->
    <div class="mainSearchFilters mat-elevation-z8" [class.filterVisible]="isDateSearch" stop-propagation *ngIf="!isModal">
        <div class="srchHeading">
            <span class="srchHeadingLabel" [textContent]="translate('Filter by date')"></span>
            <div class="closeOutlookSearch">
                <span class="material-icons cursorPointer" (click)="isDateSearch = false">close</span>
            </div>
        </div>
        <div class="selectedFilterContainer">
            <ng-container *ngTemplateOutlet="dateFilterFields"></ng-container>
        </div>
        <div class="align-items-center d-flex justify-content-end actionBtnsSection gap-2 px-3">
            <material-button class="mx-0"
                             [classList]="['mat-elevation-z1', 'inSideSearch']"
                             [text]="translate('Clear Filter')"
                             (buttonClicked)="clearSearchCriteria()"></material-button>
            <material-button
                             class="mr-2"
                             [color]="'primary'"
                             [classList]="['!w-auto']"
                             [text]="translate('Apply')"
                             [disabled]="!timeFilter.endDate || !timeFilter.startDate"
                             (buttonClicked)="searchByTimeRange()"></material-button>
        </div>
    </div>

    <ng-template #dateFilterFields>
        <div class="row mx-0">
            <div class="col-6">
                <material-input-date
                                     [placeholder]="translate('From Date')"
                                     [label]="translate('From Date')"
                                     [id]="'processStartingDate'"
                                     [title]="timeFilter.startDate || translate('From Date')"
                                     [model]="timeFilter.startDate"
                                     [inputOnlyDisabled]="true"
                                     (modelChange)="timeFilter.startDate = $event"></material-input-date>
            </div>
            <div class="col-6 timePickerContainer">
                <mat-form-field class="pt-[8px]">
                    <mat-label *ngIf="isIE || !isIE">Start Time</mat-label>
                    <ng-container *ngIf="isIE && timeFilter.startTime; else noTime">
                        <input matInput [(ngModel)]="timeFilter.startTime" readonly />
                    </ng-container>
                    <ng-template #noTime>
                        <input matInput [ngxTimepicker]="StartTimePick" [(ngModel)]="timeFilter.startTime" readonly />
                    </ng-template>
                    <material-button buttonType="mini-fab" [size]="'small'" [hideRipple]="true" matSuffix tabindex="-1">
                        <ngx-material-timepicker-toggle [for]="StartTimePick"></ngx-material-timepicker-toggle>
                    </material-button>
                    <ngx-material-timepicker
                                             #StartTimePick
                                             [theme]="darkTheme"
                                             (timeChanged)="timeFilter.startTime = $event"></ngx-material-timepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="row mx-0">
            <div class="col-6">
                <material-input-date
                                     [placeholder]="translate('To Date')"
                                     [label]="translate('To Date')"
                                     [id]="'processEndDate'"
                                     [title]="timeFilter.endDate || translate('To Date')"
                                     [model]="timeFilter.endDate"
                                     [inputOnlyDisabled]="true"
                                     (modelChange)="timeFilter.endDate = $event"></material-input-date>
            </div>
            <div class="col-6 timePickerContainer">
                <mat-form-field class="pt-[8px]">
                    <mat-label *ngIf="isIE || !isIE">End Time</mat-label>
                    <ng-container *ngIf="isIE && timeFilter.endTime; else noEndTime">
                        <input matInput [(ngModel)]="timeFilter.endTime" readonly />
                    </ng-container>
                    <ng-template #noEndTime>
                        <input matInput [ngxTimepicker]="endTimePick" [(ngModel)]="timeFilter.endTime" readonly />
                    </ng-template>
                    <material-button buttonType="mini-fab" [size]="'small'" [hideRipple]="true" matSuffix tabindex="-1">
                        <ngx-material-timepicker-toggle [for]="endTimePick"></ngx-material-timepicker-toggle>
                    </material-button>
                    <ngx-material-timepicker
                                             #endTimePick
                                             [theme]="darkTheme"
                                             (timeChanged)="timeFilter.endTime = $event"></ngx-material-timepicker>
                </mat-form-field>
            </div>
        </div>
    </ng-template>

    <ng-template #timeFilterModal>
        <div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
            <h4 class="matDialogTitle" mat-dialog-title [textContent]="translate('Filter by date')"></h4>
            <span class="material-icons mx-2" mat-dialog-close (click)="closePopup()">close</span>
        </div>
        <mat-dialog-content class="mat-typography !overflow-x-hidden">
            <div>
                <ng-container *ngTemplateOutlet="dateFilterFields"></ng-container>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end" class="justify-content-end px-3 gap-2">
            <material-button
                             class="mx-0"
                             [classList]="['mat-elevation-z1', 'inSideSearch']"
                             [text]="translate('Clear Filter')"
                             (buttonClicked)="clearSearchCriteria()"></material-button>
            <material-button
                             class="mx-0"
                             [color]="'primary'"
                             [text]="translate('Apply')"
                             [disabled]="!timeFilter.endDate || !timeFilter.startDate"
                             (buttonClicked)="searchByTimeRange()"></material-button>
        </mat-dialog-actions>
    </ng-template>
</ng-container>
